import { render, staticRenderFns } from "./UserLinkGroupsDialog.vue?vue&type=template&id=ed54815e&scoped=true&"
import script from "./UserLinkGroupsDialog.vue?vue&type=script&lang=js&"
export * from "./UserLinkGroupsDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed54815e",
  null
  
)

export default component.exports